import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {Permissoes} from '../../../../core/auth/permissoes';
import {ConfiguracaoContaEmailComponent} from './configuracao-conta-email/configuracao-conta-email.component';
import {ConfiguracaoTimelineWhatsappComponent,} from './configuracao-timeline-whatsapp/configuracao-timeline-whatsapp.component';
import {ImportarLocalizacaoErpComponent} from './importar-localizacao-erp/importar-localizacao-erp.component';
import {LogoEmpresaComponent} from './logo-empresa/logo-empresa.component';
import {ConfiguracaoRastreadoresComponent} from './configuracao-rastreadores/configuracao-rastreadores.component';


const routes: Routes = [
	{
		path: 'configuracao-email',
		data: {
			validarPermissao: true,
			chave: Permissoes.CONFIGURACOES_EMAIL
		},
		component: ConfiguracaoContaEmailComponent
	},
	{
		path: 'logo-empresa',
		component: LogoEmpresaComponent
	},
	{
		path: 'importar-localizacao',
		component: ImportarLocalizacaoErpComponent
	},
	{
		path: 'configuracao-timeline-whatsapp',
		component: ConfiguracaoTimelineWhatsappComponent
	},
	{
		path: 'configuracao-rastreadores',
		component: ConfiguracaoRastreadoresComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class FerramentasRoutingModule {
}
